import { type InputHTMLAttributes, useId } from 'react'
import { cx } from './cx.ts'

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> & {
  label: string
  /** Etykieta tylko dla czytników (Figma: pole bez etykiety, np. telefon obok „+48”). */
  labelHidden?: boolean
  error?: string
  hint?: string
}

/** Figma: `Input`. Natywny `<input>` z etykietą, podpowiedzią i błędem (aria-describedby). */
export function Input({ label, labelHidden = false, error, hint, className, ...rest }: InputProps) {
  const id = useId()
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined
  return (
    <div className="flex flex-col gap-sm">
      <label htmlFor={id} className={labelHidden ? 'sr-only' : 'text-label text-text-primary'}>
        {label}
      </label>
      <input
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={cx(
          'h-14 w-full min-w-0 rounded-card-sm border bg-bg-card px-base text-body text-text-primary placeholder:text-text-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-selected',
          error ? 'border-error' : 'border-border',
          className,
        )}
        {...rest}
      />
      {error ? (
        <span id={`${id}-error`} className="text-label text-error">
          {error}
        </span>
      ) : hint ? (
        <span id={`${id}-hint`} className="text-label text-text-secondary">
          {hint}
        </span>
      ) : null}
    </div>
  )
}
